import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import MainContent from '../components/layout/MainContent';
import Title from '../components/typography/Title';

import { TaraSearchHeader } from '../components/features/Tara';
import TaraSurveyContainer from '../containers/TaraSurveyContainer';
import SearchResultsContainer from '../containers/SearchResultsContainer';

import { actions } from '../actions/search';
import { actions as taraActions } from '../actions/tara';
import { getIsFetching } from '../reducers/search/isFetching';
import { getSearchQueryText } from '../reducers/search/queryText';
import { getSearchLastQueryText } from '../reducers/search/lastQueryText';
import { getSearchResults } from '../reducers/search/results';
import { getTaraHasMadeIntroduction } from '../reducers/tara/hasMadeIntroduction';

import { createFetchingView } from '../helpers/views';

class SearchView extends React.PureComponent {
  componentDidMount() {
    const { queryText } = this.props.locationPayload;
    const { searchLastQueryText } = this.props;

    if (queryText !== searchLastQueryText) {
      this.props.apiSearchQueryRequest(queryText.toString());
    }
  }

  componentWillReceiveProps(nextProps) {
    const { queryText } = nextProps.locationPayload;

    if (queryText !== this.props.locationPayload.queryText) {
      this.props.apiSearchQueryRequest(queryText.toString());

      if (!this.props.hasMadeIntroduction) {
        this.props.taraSetHasMadeIntroduction(true);
      }
    }
  }

  componentWillUnmount() {
    if (!this.props.hasMadeIntroduction) {
      this.props.taraSetHasMadeIntroduction(true);
    }
  }

  get shouldRenderTaraSurvey() {
    const { features, locationQuery, surveyCompleted } = this.props;

    return !!locationQuery.tara && features.taraSurvey && !surveyCompleted;
  }

  renderTitle() {
    const { tara } = this.props.locationQuery;
    const { searchLastQueryText, searchQueryText } = this.props;
    const queryText = searchLastQueryText;

    if (tara) {
      return (
        <TaraSearchHeader
          queryText={queryText}
          searchResults={this.props.searchResults}
          hasMadeIntroduction={this.props.hasMadeIntroduction}
          isFetching={this.props.isFetching}
        />
      );
    }

    return (
      <Title align="center">Search results for "{queryText}"</Title>
    );
  }

  renderContent() {
    const { curated, tara } = this.props.locationQuery;
    return (
      <MainContent
        id="SearchView"
        className="sk-fade-in-quarter-second"
      >
        {this.renderTitle()}

        <SearchResultsContainer />
        {this.shouldRenderTaraSurvey && (<TaraSurveyContainer />)}
      </MainContent>
    );
  }

  render() {
    if (this.props.isReady) {
      window.CE_SNAPSHOT_NAME = "http://simplifytickets.com/search/texas%20rangers";
      return this.renderContent();
    }

    return null;
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetching: getIsFetching(state),
  searchLastQueryText: getSearchLastQueryText(state),
  searchQueryText: getSearchQueryText(state),
  searchResults: getSearchResults(state),
  hasMadeIntroduction: getTaraHasMadeIntroduction(state),
  ...ownProps,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  apiSearchQueryRequest: actions.apiSearchQueryRequest,
  taraSetHasMadeIntroduction: taraActions.taraSetHasMadeIntroduction,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(createFetchingView(SearchView));



// WEBPACK FOOTER //
// ./src/views/SearchView.js